module.exports = __webpack_public_path__ + "static/media/boy-africa.06ab9dd4.jpg";